angular.module('mtic.components.dashboards.teacher_general')
.component('teacherClassesStudents', {
  
  templateUrl: 'template.html',
  bindings: {
    
  },
  controllerAs: '$ctrl',
  controller($scope, $log, language, EventManager, TeacherDataService) {

    var eventManager = new EventManager('teacherClassesSchools', $scope);

    $scope.language = language;
    const $ctrl = this;
    const text = $scope.text = {
      SCHOOL: 'School',
      MODULES: 'Module',
      CLASSES: 'Classes',
      ACCOUNTSETUPISBAD: 'Your account appears to not be configured correctly.'
    }
    $ctrl.flags = {
      loading: true,
      error: null,
      reset() {
        this.loading = true;
        this.error = null;
      },
      done(error) {
        this.loading = false;
        if(error) {
          this.error = error;
        }
      }
    }

    $ctrl.schools = {
      list: [],
      hasMany: false,
      hasNone: false,
      filter: {},
      selected: null
    }

    var getSchools = function(reset){
      return TeacherDataService.getUserSchools(null, reset)
      .then( function(schools) {
        $ctrl.schools.list = schools;
        $ctrl.schools.hasMany = schools.length > 1;
        $ctrl.schools.hasNone = schools.length < 1;
        $ctrl.schools.selected = schools[0];
      } )
    }

    $ctrl.$onInit = function() {
      $ctrl.flags.reset();
      getSchools(true)
      .then(function(){ 
        $ctrl.flags.done() 
      })
      .catch( function(err){
        $log.error(err);
        $ctrl.flags.done(err.message)
      })
    }

  }
});
